import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { Button, Icon, List, Modal } from 'semantic-ui-react';
import {
  DeleteConfirmation,
  MobileModal,
  Analytics,
  GlobalNotifications,
  Intent
} from '../../Modules';
import styleVariables from '../../variables';
import documentStyles from '../Document.scss';
import Share from './Share';
import Actions from '../Sections/Actions/Actions';
import moment from 'moment-timezone';

export default class ContractActions extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    node: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    windowDimensions: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      alreadySignedModalOpen: false,
      deleteModalOpen: false
    };
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.deleteContract = this.deleteContract.bind(this);
    this.saveContractAsTemplate = this.saveContractAsTemplate.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.print = this.print.bind(this);
  }

  deleteContract() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to delete contract',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully deleted contract',
        intent: Intent.SUCCESS
      });
      this.props.router.push(
        `/events/${this.props.node.workspaces.edges[0].node.event
          .id}/workspaces`
      );
      Analytics.trackEvent('deleted-contract');
    };

    const mutation = graphql`
      mutation ActionsComponent_deleteContractMutation(
        $input: DeleteContractInput!
      ) {
        deleteContract(input: $input) {
          deletedContractId
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: { input: { id: this.props.node.id } },
      onCompleted,
      onError
    });
  }

  saveContractAsTemplate() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to create template',
        intent: Intent.DANGER
      });
    };
    const onCompleted = response => {
      GlobalNotifications.show({
        message: 'Successfully created template',
        intent: Intent.SUCCESS
      });
      this.props.router.push(
        `/templates/c/${response.saveContractAsTemplate.c_template.id}`
      );
      Analytics.trackEvent('created-contract-template', {
        source: 'existing-contract'
      });
    };

    const mutation = graphql`
      mutation ActionsComponent_saveContractAsTemplateMutation(
        $input: SaveContractAsTemplateInput!
      ) {
        saveContractAsTemplate(input: $input) {
          c_template {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: { input: { contract_id: this.props.node.id } },
      onCompleted,
      onError
    });
  }

  openDeleteModal() {
    this.setState({ deleteModalOpen: true });
  }

  closeDeleteModal() {
    this.selectItem();
    this.setState({ deleteModalOpen: false });
  }

  selectItem(callback) {
    if (this.props.onClose) this.props.onClose();
    if (callback) callback();
  }

  downloadPdf() {
    window.location = `/contracts/${this.props.node.id}.pdf?tz=${moment.tz.guess()}`;
  }

  print() {
    window.location = `/contracts/${this.props.node.id}.pdf?tz=${moment.tz.guess()}&disposition=inline`;
  }

  render() {
    return (
      <div>
        <DeleteConfirmation
          delete={this.deleteContract}
          id={this.props.node.id}
          open={this.state.deleteModalOpen}
          onClose={this.closeDeleteModal}
        />
        <Actions
          windowDimensions={this.props.windowDimensions}
          onClose={this.props.onClose}
        >
          <List>
            {this.props.params.action === 'edit' &&
              this.props.node.can_edit &&
              <List.Item
                onClick={() => this.props.router.replace(`/docs/c/${this.props.node.id}`)}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='eye' /> &nbsp; Preview
              </List.Item>}
            {this.props.params.action !== 'edit' &&
              this.props.node.editable &&
              this.props.node.can_edit &&
              <List.Item
                onClick={() => this.props.router.replace(`/docs/c/${this.props.node.id}/edit`)}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='pencil' /> &nbsp; Edit
              </List.Item>}
            {this.props.params.action !== 'edit' &&
              this.props.node.can_edit &&
              !this.props.node.editable &&
              this.props.windowDimensions.width >=
                styleVariables.tabletBreakpoint &&
              <Modal
                trigger={
                  <List.Item className={documentStyles.actionMenuItem}>
                    <Icon name='pencil' /> &nbsp; Edit
                  </List.Item>
                }
                size='small'
                onOpen={() => this.setState({ alreadySignedModalOpen: true })}
                onClose={this.selectItem.bind(null, () =>
                  this.setState({ alreadySignedModalOpen: false })
                )}
                open={this.state.alreadySignedModalOpen}
              >
                <Modal.Header>Contract has already been signed</Modal.Header>
                <Modal.Content>
                  <p>
                    You cannot make changes to this contract since it has
                    already been signed.
                  </p>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    basic
                    content='Close'
                    onClick={this.selectItem.bind(null, () =>
                      this.setState({ alreadySignedModalOpen: false })
                    )}
                  />
                </Modal.Actions>
              </Modal>}
            {this.props.node.can_edit &&
            this.props.params.action !== 'edit' &&
            !this.props.node.editable &&
            this.props.windowDimensions.width <
              styleVariables.tabletBreakpoint && [
                <List.Item
                  key='edit'
                  className={documentStyles.actionMenuItem}
                  onClick={() => this.setState({ alreadySignedModalOpen: true })}
                >
                  <Icon name='pencil' /> &nbsp; Edit
                </List.Item>,
                <MobileModal open={this.state.alreadySignedModalOpen} key='modal'>
                  <MobileModal.Header>
                    <div className='menu'>
                      <a
                        className='item'
                        onClick={this.selectItem.bind(null, () =>
                          this.setState({ alreadySignedModalOpen: false })
                        )}
                      >
                        <Icon name='chevron left' />
                      </a>
                    </div>
                  </MobileModal.Header>
                  <MobileModal.Content>
                    <h4>Contract has already been signed</h4>
                    <p>
                      You cannot make changes to this contract since it has
                      already been signed.
                    </p>
                    <Button
                      basic
                      fluid
                      content='Close'
                      onClick={this.selectItem.bind(null, () =>
                        this.setState({ alreadySignedModalOpen: false })
                      )}
                      style={{ marginTop: '2em' }}
                    />
                  </MobileModal.Content>
                </MobileModal>
              ]}
            <Share
              document={this.props.node}
              trigger={
                <List.Item className={documentStyles.actionMenuItem}>
                  <Icon name='share' /> &nbsp; Share
                </List.Item>
              }
              onClose={this.selectItem}
              relay={this.props.relay}
            />
            {this.props.node.can_edit &&
              <List.Item
                className={documentStyles.actionMenuItem}
                onClick={this.selectItem.bind(
                  null,
                  this.saveContractAsTemplate
                )}
              >
                <Icon name='copy outline' /> &nbsp; Save As Template
              </List.Item>}
            <List.Item
              onClick={this.print}
              className={documentStyles.actionMenuItem}
            >
              <Icon name='print' /> &nbsp; Print
            </List.Item>
            <List.Item
              onClick={this.downloadPdf}
              className={documentStyles.actionMenuItem}
            >
              <Icon name='download' /> &nbsp; Download PDF
            </List.Item>
            {this.props.node.can_edit &&
              this.props.node.deletable &&
              <List.Item
                onClick={this.openDeleteModal}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='trash alternate' /> &nbsp; Delete Contract
              </List.Item>}
          </List>
        </Actions>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/Actions.js